var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJustification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 14.1667H3.33325V15.8334H11.6666V14.1667ZM16.6666 7.50008H3.33325V9.16675H16.6666V7.50008ZM3.33325 12.5001H16.6666V10.8334H3.33325V12.5001ZM3.33325 4.16675V5.83341H16.6666V4.16675H3.33325Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustification);
export default __webpack_public_path__ + "static/media/Justification.2625acb0e882788af45bb99200639cef.svg";
export { ForwardRef as ReactComponent };